import { generatePath } from "react-router-dom";

import { URLS } from "@/api/urls";
import { Sentiment } from "@/constants";
import { PaginatedSearchMentions } from "@/types/PaginatedSearchMentions";

import fetcher_v2 from "../fetcher_v2";

export const getEpisodes = (filters = {}) => {
  return fetcher_v2<PaginatedSearchMentions>(URLS.MENTIONS, {
    method: "GET",
    body: filters,
  });
};

export const getPublicEpisodes = (filters = {}) => {
  return fetcher_v2(URLS.MENTIONS, {
    method: "GET",
    body: filters,
  });
};

export const resetMentions = (uuid: string) => {
  return fetcher_v2(generatePath(URLS.MENTIONS_RESET, { uuid }), {
    method: "POST",
  });
};

export const setSentiment = (mention_uuids: Uuid[], sentiment: string) => {
  return fetcher_v2<{ aggregated_sentiment: Sentiment; insights: [] }>(
    URLS.MENTION_SET_SENTIMENT,
    {
      method: "POST",
      body: {
        sentiment,
        mention_uuids,
      },
    }
  );
};

export const amendMention = (
  public_id: string,
  { mention_text }: { mention_text: string }
) => {
  return fetcher_v2(generatePath(URLS.MENTION_AMEND, { public_id }), {
    method: "PATCH",
    body: { amended_text: mention_text },
  });
};

export const getFullTranscript = (pk: number) => {
  return fetcher_v2(generatePath(URLS.FULL_TRANSCRIPT, { pk }), {
    method: "GET",
  });
};

export const requestTranscription = (episode_pk: string) => {
  return fetcher_v2(generatePath(URLS.REQUEST_TRANSCRIBE, { episode_pk }), {
    method: "POST",
  });
};
